import React, { Component } from "react";
import PropTypes from "prop-types";


import { getMenu } from "../requests/req_auth";
import { amb, notifica } from "../requests/utils";

import Menu from "../components/Menu";
import Header from "../components/Header";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = { opcion: "Inicio", menu: null };
    this.menu = this.menu.bind(this);
    this.childHandler = this.childHandler.bind(this);
  }

  componentDidMount() {
    getMenu((x) => this.menu(x));
  }

  menu(datos) {
    if (datos) {
      if (datos.code === 1) {
        notifica("warning", datos.message, "Error!");
        sessionStorage.removeItem(amb + "UD");
        window.location = "/auth/login";
      } else {
        this.setState({ menu: datos.data });
      }
    } else {
      sessionStorage.removeItem(amb + "UD");
      window.location = "/auth/login";
    }
  }

  childHandler(dataFromChild) {
    this.setState({ opcion: dataFromChild });
  }

  render() {
    const { children } = this.props;

    return (
      <div className="dv_main">
        <Menu action={this.childHandler} datos={this.state.menu} />
        <div className="dv_cont" id="dv_contenido">
          <Header />
          <div id="dv_subCont">{children}</div>
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
